import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  Input,
  TemplateRef,
} from '@angular/core';

import { IonicModule } from '@ionic/angular';

import { tsAwaitSpinnerContext } from '../await-spinner/await-spinner.directive';
import { SpinnerUiComponent } from '../spinner-ui/spinner-ui.component';

interface SpinnerUiContext<T> {
  tsAwaitSpinner: T;
}

@Component({
  selector: 'ts-await-spinner-ui',
  templateUrl: './await-spinner-ui.component.html',
  styleUrls: ['./await-spinner-ui.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, IonicModule, SpinnerUiComponent],
})
export class AwaitSpinnerUiComponent<T> {
  @Input({ required: true }) templateRef!: TemplateRef<
    tsAwaitSpinnerContext<T>
  >;
  @Input({ required: true }) isShowSpinner!: boolean;
  @Input() context?: SpinnerUiContext<T>;
}
